type CarItemFromLicense = {
  data: {
    brand: string;
    style: string;
    yearManufacture: string;
    capacity: string;
    vin: string;
    engineSerial: string;
    displacement: string;
    model: string;
    cylinders: string;
    chassis: string;
    fuel: string;
    color: string;
  };
};

export function makeEmpty(): CarItemFromLicense {
  return {
    data: {
      brand: '',
      style: '',
      yearManufacture: '',
      capacity: '',
      vin: '',
      engineSerial: '',
      displacement: '',
      model: '',
      cylinders: '',
      chassis: '',
      fuel: '',
      color: '',
    },
  };
}

export default CarItemFromLicense;
